<template>
  <div id="app" v-onmedia="matchMedia">

    <!-- Main Navigation -->
    <header>

        <!-- Navbar -->
        <nav class="navbar navbar-expand-lg navbar-dark fixed-top scrolling-navbar">
            <div class="container navbar-width">
                <a class="navbar-brand" href="#home" v-smooth-scroll="{ duration: 3000, offset: -50 }">
                    <img src="./assets/img/logo_white_bg.png" alt="Logo" class="logo show-at-top"/>
                    <img src="./assets/img/logo.png" alt="Logo" class="logo show-at-scroll"/>
                    <span class="sr-only">(current)</span>
                </a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent-7" aria-controls="navbarSupportedContent-7" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent-7">
                    <ul class="navbar-nav mr-auto" style="font-size: 1.1rem;padding-top:10px;">
                        <!--<li class="nav-item active">
                            <a class="nav-link" href="#home">Home <span class="sr-only">(current)</span></a>
                        </li>-->
                        <li class="nav-item">
                            <a class="nav-link" 
                            v-smooth-scroll="{ duration: 3000, offset: getOffset()-84 }" 
                            href="#people" 
                            data-offset="220" 
                            data-toggle="collapse" 
                            data-target="#navbarSupportedContent-7" v-lang.acting>Schauspiel</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" 
                            v-smooth-scroll="{ duration: 3000, offset: getOffset() }" 
                            href="#news" 
                            data-offset="70" 
                            data-toggle="collapse" 
                            data-target="#navbarSupportedContent-7">News</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" 
                            v-smooth-scroll="{ duration: 3000, offset: getOffset() }" 
                            href="#agency" 
                            data-offset="70" 
                            data-toggle="collapse" 
                            data-target="#navbarSupportedContent-7" v-lang.agentur>Agentur</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" 
                            v-smooth-scroll="{ duration: 3000, offset: getOffset() }" 
                            href="#contact" 
                            data-offset="70" 
                            data-toggle="collapse" 
                            data-target="#navbarSupportedContent-7" v-lang.kontakt>Kontakt</a>
                        </li>
                    </ul>
                    <!--<div>
                        <a class="icons-sm fb-ic" 
                            @click="language = 'fr'" 
                            href="#"
                            v-if="isLanguageNotFrench"
                            data-toggle="collapse"
                            >
                            <img src="./assets/img/french.png" alt="Francais" class="language-icon"/></a>
                        <a class="icons-sm fb-ic" 
                            @click="language = 'de'" 
                            href="#"
                            v-if="isLanguageNotGerman"
                            data-toggle="collapse"
                            >
                            <img src="./assets/img/german.png" alt="Deutsch" class="language-icon"/></a>
                    </div>-->
                    <div class="hidden-md-down">
                        <!-- Facebook -->                   
                        <a class="icons-sm fb-ic" 
                            target="_blank" 
                            href="https://www.facebook.com/pages/Heimanns-Agentur/174592245925723">
                            <i class="fa fa-facebook white-text"> </i></a>
                        <!-- Instagram -->
                        <a class="icons-sm fb-ic" 
                            target="_blank" 
                            href="https://www.instagram.com/heimann.s_agentur/">
                            <i class="fa fa-instagram white-text"> </i></a>
                    </div>
                </div>
            </div>
        </nav>

    </header>
    <!-- Main Navigation -->


    <!-- Main Layout -->
    <main>

        <!--<div id="home" style="height:90px;"></div>-->
        
        <section-people></section-people>

        <section-news style="margin:0px;padding:0px;"></section-news>
        
        <div class="view intro hm-white-light jarallax parallax-img-2" data-jarallax='{"speed": 0.2}'>
            <div class="mask pattern-5 full-bg-img">
                <div class="container">
                    <div class="d-flex align-items-center d-flex justify-content-center">
                        <div class="row mt-5">
                            <div class="col-md-12 wow fadeIn mt-5 mb-3">
                                <div class="text-center">
                                    <p class="display-1 mb-2 wow fadeInDown white-text" data-wow-delay="0.3s" style="font-size:3rem;margin-top:120px;" v-lang.agentur>Agentur</p>
    <!--                                <h5 class="font-up mb-3 mt-1 font-bold wow fadeIn" data-wow-delay="0.4s">Interior designer & Nature lover</h5>
                                    <a class="btn btn-elegant btn-lg wow fadeIn" data-wow-delay="0.4s">portfolio</a> <a class="btn btn-outline-white btn-lg wow fadeIn" data-wow-delay="0.4s">About me</a> 
    -->                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

       <!--<section-parallax></section-parallax>-->

        <!--<section-people></section-people>-->

        <section-agency></section-agency>

<!--
        <div class="view intro hm-white-light jarallax parallax-img-1" data-jarallax='{"speed": 0.2}'>
            <div class="mask pattern-5 full-bg-img">
                <div class="container">
                    <div class="d-flex align-items-center d-flex justify-content-center">
                        <div class="row mt-5">
                            <div class="col-md-12 wow fadeIn mt-5 mb-3">
                                <div class="text-center">
                                    <p class="display-1 mb-2 wow fadeInDown white-text" 
                                    data-wow-delay="0.3s" 
                                    style="font-size:3rem;" v-lang.kontakt>Kontakt</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
-->
         <section-contact></section-contact>
            
    
    </main>
    <!-- Main Layout -->
   
    <section-footer></section-footer>

    <modal-imprint></modal-imprint>
    <modal-data-protection></modal-data-protection>

  </div>
</template>

<script>
    import People from './components/People'
    import News from './components/News'
    import Agency from './components/Agency'
    import Contact from './components/Contact'
    import Imprint from './components/Imprint'
    import Footer from './components/Footer'
    import Parallax from './components/Parallax'
    import DataProtection from './components/DataProtection.vue'

    export default {
        data () {
            return {
                matchedSize : '',
                scrollOffset: -60
            }
        },
        components: {
           sectionPeople : People ,
           sectionNews : News,
           sectionAgency : Agency ,
           sectionContact: Contact,
           modalImprint: Imprint,
           sectionFooter: Footer,
           sectionParallax: Parallax,
           modalDataProtection: DataProtection
        }
        ,
        computed: {
            isLanguageNotFrench() {
                return this.language !== 'fr';
            },
            isLanguageNotGerman() {
                return this.language !== 'de';
            }
        },
        methods: {
            matchMedia(alias, matches) {
                if (alias === 'xs' && matches) {
                    //console.log("xs");
                    this.matchedSize = 'xs';
                    this.scrollOffset = -200;
                } else if (alias === 'sm' && matches) {
                    //console.log("sm");
                    this.matchedSize = 'sm';
                    this.scrollOffset = -200;
                } else if (alias === 'md' && matches) {
                    //console.log("md");
                    this.matchedSize = 'md';
                    this.scrollOffset = -100;
                } else if (alias === 'lg' && matches) {
                    //console.log("lg");
                    this.matchedSize = 'lg';
                    this.scrollOffset = -100;
                } else if (alias === 'xl' && matches) {
                    //console.log("xl");
                    this.matchedSize = 'xl';
                    this.scrollOffset = -100;
                }               
            },
            getOffset() {
                console.log("offset is: " + this.scrollOffset);
                return this.scrollOffset;
            }
        }
    }
</script>

<style>
        .container.navbar-width {
            min-width:95%;
        }
        @media (max-width: 1200px) {
            .container.navbar-width {
                min-width:91%;
                max-width:95%
            }
        }
        @media (max-width: 992px) {
            .container.navbar-width {
                min-width:86%;
                max-width:86%;
            }
        }

    .logo {
        width: 200px;
        margin-right: 20px;
    }

    @media (max-width: 767px) {
        .logo {
            width: 100px; /*120px;*/
        }
    }

    .language-icon {
        width: 24px;
        margin-top:-2px;
    }
    @media (max-width: 991px) {
        .language-icon {
            margin: 10px;
        }
    }

    .show-at-top {
        display:none;
    }
    .show-at-scroll {
        display:inherit;
    }

    .jarallax {
        min-height: 180px;
    }

    .parallax-img-1 {
        background: url('./assets/img/strahlen.png');
        height: 260px;
    }
    .parallax-img-2 {
        background: url('./assets/img/IMG_2267-1.jpg');
        height: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue